import React from "react";
import styled from "styled-components";

import LineSeedKrRg from "../../../../atoms/text/lineSeedKr/lineSeedKrRg";

const LSRgH1HeadLine = (props) => {
  return <LSRgH1HeadLineWrapper {...props} />;
};

export default LSRgH1HeadLine;

const LSRgH1HeadLineWrapper = styled(LineSeedKrRg)`
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  letter-spacing: -0.6px;

  color: #222222;
`;
